// Rednas Kitchen — minimale interactie
(function () {
  // Productgalerij: afbeeldingen én video als volwaardig media-item (plan 2b.2)
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll(".thumbs button");
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        thumbs.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        if (btn.dataset.mediaType === "video") {
          main.innerHTML =
            '<video controls autoplay muted playsinline preload="metadata" poster="' +
            btn.dataset.poster + '"><source src="' + btn.dataset.src + '" type="video/mp4"></video>';
        } else {
          main.innerHTML = '<img src="' + btn.dataset.src + '" alt="' + (btn.dataset.alt || "") + '">';
        }
      });
    });
  });

  // Voorraadmelding (1.1) — front-end demo; koppeling met Shopify/Klaviyo volgt bij livegang
  document.querySelectorAll("[data-notify]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      form.innerHTML = '<p style="margin:0"><strong>Dank je.</strong> We sturen je bericht zodra het product er weer is.</p>';
    });
  });


  // Top Trending carrousel: pijltjes schuiven één kaart op, swipen werkt vanzelf
  document.querySelectorAll("[data-carousel]").forEach(function (carousel) {
    var track = carousel.querySelector("[data-carousel-track]");
    var prev = carousel.querySelector("[data-carousel-prev]");
    var next = carousel.querySelector("[data-carousel-next]");
    if (!track || !prev || !next) return;

    function stap() {
      var kaart = track.querySelector(".prod-card");
      if (!kaart) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || "0") || 0;
      return kaart.getBoundingClientRect().width + gap;
    }
    function ververs() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -stap(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: stap(), behavior: "smooth" }); });
    track.addEventListener("scroll", ververs, { passive: true });
    window.addEventListener("resize", ververs);
    ververs();
  });

  // Herroepingsformulier: tekstuele validatie en bevestiging op het scherm
  document.querySelectorAll("[data-herroep]").forEach(function (form) {
    var foutvak = form.querySelector("[data-form-errors]");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var fouten = [];
      form.querySelectorAll("[required]").forEach(function (veld) {
        veld.classList.remove("veld-fout");
        var naamVeld = (veld.name || "").replace(/^contact\[/, "").replace(/\]$/, "").replace(/^email$/, "E-mailadres");
        if (!veld.value.trim()) {
          fouten.push(naamVeld + " is nog niet ingevuld.");
          veld.classList.add("veld-fout");
        } else if (veld.type === "email" && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(veld.value)) {
          fouten.push("Vul een geldig e-mailadres in.");
          veld.classList.add("veld-fout");
        }
      });

      if (fouten.length) {
        foutvak.innerHTML = "<strong>Controleer de volgende velden:</strong><ul>" +
          fouten.map(function (f) { return "<li>" + f + "</li>"; }).join("") + "</ul>";
        foutvak.hidden = false;
        foutvak.focus();
        return;
      }
      // geldig: versturen naar Shopify, die de bevestiging toont na terugkeer
      form.submit();
    });
  });

  // Meescrollende koopbalk: zichtbaar zodra de gewone bestelknop uit beeld is.
  // De WhatsApp-knop moet er dan bovenuit schuiven, daarom geeft dit script de
  // hoogte van de balk door aan de CSS.
  var koopbalk = document.querySelector("[data-koopbalk]");
  var hoofdknop = document.querySelector('.pdp-info form[action$="/cart/add"] [name="add"]');
  if (koopbalk && hoofdknop) {
    koopbalk.hidden = false;
    var balkWacht = false;

    function balkKijk() {
      balkWacht = false;
      // alleen tonen als de gewone knop boven het scherm uit is gescrold,
      // niet als hij er nog onder zit bij het laden van de pagina
      var toon = hoofdknop.getBoundingClientRect().bottom < 0;
      koopbalk.classList.toggle("zichtbaar", toon);
      document.documentElement.style.setProperty(
        "--koopbalk", toon ? koopbalk.offsetHeight + "px" : "0px");
    }
    function balkPlan() {
      if (balkWacht) return;
      balkWacht = true;
      requestAnimationFrame(balkKijk);
    }

    window.addEventListener("scroll", balkPlan, { passive: true });
    window.addEventListener("resize", balkPlan);
    balkKijk();
  }

  // Hero-video: pauzeer buiten beeld (laadtijd/CWV, plan 2b.1).
  // Staat het systeem van de bezoeker op beperkte beweging, dan speelt de video
  // niet vanzelf maar krijgt hij bediening, zodat hij zelf kan kiezen.
  var heroVideo = document.querySelector("[data-hero-media] video");
  var minderBeweging = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (heroVideo && minderBeweging) {
    heroVideo.removeAttribute("autoplay");
    heroVideo.setAttribute("controls", "");
    heroVideo.pause();
  } else if (heroVideo && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { heroVideo.play().catch(function () {}); }
        else { heroVideo.pause(); }
      });
    }).observe(heroVideo);
  }
})();
